import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { getPageStatus, PageLayout } from 'components/PageLayout';
import { useAuthState } from 'state/useAuthState';
import { FirePerimeterForm } from './FirePerimeterForm';
import { useFirePerimeter } from './FirePerimeterForm/FirePerimeterForm.utils';

export const EditFirePerimeter = (
  props: RouteComponentProps<{ perimeterId: string }>,
): JSX.Element => {
  const {
    match: {
      params: { perimeterId },
    },
  } = props;
  const { t } = useTranslation();
  const {
    permissions: { isWildfireStaffReporter },
  } = useAuthState();

  const id = Number(perimeterId);
  const {
    data: firePerimeter,
    isLoading,
    isError,
  } = useFirePerimeter(isWildfireStaffReporter ? id : undefined);

  const title = t('editFirePerimeter.title');

  const status = getPageStatus({
    isUnauthorized: !isWildfireStaffReporter,
    isLoading,
    isError: isError || !firePerimeter,
  });

  return (
    <PageLayout
      data-cname="EditFirePerimeter"
      status={status}
      headerBarProps={{
        title,
        action: 'back',
      }}
      errorMessage={
        !firePerimeter ? t('editFirePerimeter.errors.notFound') : undefined
      }
    >
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {firePerimeter && <FirePerimeterForm firePerimeter={firePerimeter} />}
    </PageLayout>
  );
};
